import { Container } from "react-bootstrap";

function PoliticasPrivacidad() {
  return (
    <Container className="mt-5 mb-5">
      {/* Señal de carga completa para el pre-renderizador (para páginas estáticas) */}
      <div id="snap-ready" style={{ display: "none" }}></div>

      <h1 className="mb-4">Políticas de Privacidad</h1>
      <p>
        <strong>Última actualización: 8 de agosto de 2026</strong>
      </p>

      <h4>1. Información que recopilamos</h4>
      <p>
        En ROMI STORE EC, recopilamos información personal que usted nos
        proporciona voluntariamente al realizar una compra, registrarse en
        nuestro sitio o suscribirse a nuestro boletín. Esto puede incluir su
        nombre, dirección, dirección de correo electrónico y número de teléfono.
      </p>
      <p>
        En las páginas de campaña ofrecemos una autorización opcional y
        específica para dar seguimiento por WhatsApp a un pedido incompleto.
        Solo después de marcar esa opción y completar un nombre y WhatsApp
        válidos guardamos: nombre, número de WhatsApp, producto y oferta
        elegidos, página de campaña, fecha e identificador temporal del intento.
        Antes de confirmar la compra no guardamos para este seguimiento la
        dirección, referencias ni observaciones de entrega.
      </p>

      <h4>2. Uso de su información</h4>
      <p>
        Utilizamos la información recopilada para procesar sus pedidos, mejorar
        su experiencia de compra y enviarle actualizaciones sobre nuestros
        productos y ofertas, siempre que haya dado su consentimiento.
      </p>
      <p>
        Si autoriza el seguimiento de un pedido incompleto, utilizamos esos
        datos únicamente para contactarle por WhatsApp y ayudarle a completar
        esa oferta. Al confirmar el pedido, el intento se marca como convertido
        y los datos de entrega se procesan como parte de la compra.
      </p>

      <h4>3. Medición mejorada opcional con Meta</h4>
      <p>
        En el formulario de las páginas de campaña puede elegir, mediante una
        casilla separada y opcional, si autoriza la medición mejorada de
        anuncios. Si la marca, ROMI STORE EC podrá enviar a Meta hashes SHA-256
        de su nombre y número de WhatsApp, además de producto, cantidad, precio,
        identificador del pedido, fecha y página de campaña. Meta es el
        destinatario de esos datos y la finalidad es atribuir pedidos a los
        anuncios y medir su rendimiento.
      </p>
      <p>
        El hash reduce la exposición del dato original, pero sigue siendo un
        identificador seudonimizado. Para esta medición mejorada nunca enviamos
        dirección, referencias ni observaciones de entrega. La autorización no
        es necesaria para comprar y puede dejar la casilla sin marcar. Esta
        autorización es distinta de la medición técnica básica mediante Meta
        Pixel descrita más adelante.
      </p>

      <h4>4. Protección de datos</h4>
      <p>
        Implementamos medidas de seguridad para mantener la seguridad de su
        información personal. No vendemos, intercambiamos ni transferimos a
        terceros sus datos personales sin su consentimiento, excepto para fines
        expresos de entrega del producto (ej. empresas de mensajería).
      </p>
      <p>
        La tienda utiliza Firebase, un servicio de Google, para almacenar los
        registros necesarios para operar el sitio. También utiliza Meta Pixel
        para medir visitas e interacciones con las campañas publicitarias. Estas
        herramientas pueden procesar datos técnicos del navegador conforme a
        sus propias condiciones y políticas.
      </p>

      <h4>5. Cookies</h4>
      <p>
        Nuestro sitio utiliza cookies para mejorar la experiencia del usuario.
        Usted puede elegir desactivar las cookies a través de la configuración
        de su navegador, aunque esto podría afectar la funcionalidad de la
        tienda.
      </p>

      <h4>6. Retiro del consentimiento y derechos</h4>
      <p>
        Puede retirar su autorización de seguimiento o de medición mejorada,
        pedir acceso, actualización o eliminación de sus datos, o realizar una
        consulta, escribiendo a <a href="mailto:romistore.ec@gmail.com">romistore.ec@gmail.com</a>{" "}
        o por WhatsApp al <a href="https://wa.me/593994683079">+593 99 468 3079</a>.
        Atenderemos la solicitud después de verificar razonablemente la
        identidad de la persona solicitante.
      </p>
      <p>
        Antes de confirmar un pedido puede retirar la autorización simplemente
        desmarcando la casilla. Después de confirmarlo, una solicitud de retiro
        detendrá los nuevos envíos de medición que aún no se hayan realizado;
        los datos que Meta ya haya recibido se tratarán también conforme a sus
        políticas y a los derechos que resulten aplicables.
      </p>
    </Container>
  );
}

export default PoliticasPrivacidad;
